import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitle',
  props: {
	text: {
		type: String,
		default: () => "",
	},
	backgroundImageClass: {
		type: String,
		default: () => "",
	},
	textColor: {
		type: String,
		default: () => "#ffffff",
	},
	borderColor: {
		type: String,
		default: () => "#ffffff",
	},
	maxHeight: {
		type: String,
		default: () => "",
	},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['title-wrapper', __props.backgroundImageClass]),
    style: _normalizeStyle({ height: __props.maxHeight || '90vh' })
  }, [
    _createElementVNode("h1", {
      class: "title",
      style: _normalizeStyle({
				color: __props.textColor || '#ffffff',
				borderBottom: `4px solid ${__props.borderColor || '#ffffff'}`,
			})
    }, _toDisplayString(__props.text), 5),
    _renderSlot(_ctx.$slots, "main-action")
  ], 6))
}
}

})